import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import type { CountryParticipants as CountryParticipantsRow } from '@/types';
import { CountryParticipantsChart } from './CountryParticipantsChart';

export function CountryParticipants({
  data,
}: {
  data: CountryParticipantsRow[];
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Participants by Country</CardTitle>
        <CardDescription>
          Total participants submitted for each country (top 10)
        </CardDescription>
      </CardHeader>
      <CardContent>
        <CountryParticipantsChart data={data} />
      </CardContent>
    </Card>
  );
}
